module.exports = __webpack_public_path__ + "img/aE-mD.ccbfd81a.png";